import React from 'react';
import Navbar from './Navbar/Navbar';
import ApiCollections from '../Sidebar/ApiCollections';
import HistoryPanel from '../History/HistoryPanel';

export default function Layout({ children, history, setHistory, setSelectedRequest }) {
  return (
    <>
      <Navbar />
      <div className="flex h-screen pt-[85px]">
        <ApiCollections onRequestSelect={setSelectedRequest} />
        <main className="flex-1 overflow-y-auto py-10 bg-white">
          <div className="max-w-6xl mx-[20px]">{children}</div>
        </main>
        <HistoryPanel history={history} setHistory={setHistory} />
      </div>
    </>
  );
}